
import { Vue, Options } from "vue-class-component";
import CanvasColor from "../components/Controls/CanvasColor.vue";
import FontBgColor from "../components/Controls/FontBgColor.vue";
import FontColor from "../components/Controls/FontColor.vue";
import FontSelect from "../components/Controls/FontSelect.vue";
import FontSize from "../components/Controls/FontSize.vue";
import FontWeight from "../components/Controls/FontWeight.vue";
import FontStroke from "../components/Controls/FontStroke.vue";

@Options({
  components: {
    CanvasColor,
    FontBgColor,
    FontSelect,
    FontSize,
    FontWeight,
    FontColor,
    FontStroke,
  },
})
export default class Settings extends Vue {}
